import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faPlus,
  faEye,
  faTimes,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class ReportsColumnSelectionView extends React.Component {
  groupId = { value: "" };
  state = {
    url: `${apiUrl.apiUrl.url}/lease-report`,
    gridColumns: [],
    myArray: [],
    checkedItems: new Map(),
  };

  componentDidMount() {
    console.log(this.props.report);
    var ths = this;
    if (this.props.loadedColumns.length == 0) {
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/leads/get-report-columns`,
        data: { reportType: this.props.report },
      }).then(function (response) {
        console.log(response.data, "response");
        ths.setState({ gridColumns: response.data });
        ths.props.setLoadedColumns(response.data);
        console.table(response.data)
      });
    } else {
      this.setState({ gridColumns: this.props.loadedColumns });
    }
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setInputState(columns) {
    this.setState({ gridColumns: columns });
  }

  handleChange(event) {
    var isChecked = event.target.checked;
    var item = event.target.value;
    var myArray = this.state.gridColumns;
    var objIndex = myArray.findIndex((obj) => obj.name == item);
    myArray[objIndex].visible = isChecked;
    this.setState({ gridColumns: myArray, myArray: myArray });
  }
  handleSubmit(event) {
    console.log(this.state);
    event.preventDefault();
  }

  handleOnDragEnd = (e) => {
    console.log(e);
    if (!e.destination) return;
    const items = Array.from(this.state.gridColumns);
    const [reorderedItem] = items.splice(e.source.index, 1);
    items.splice(e.destination.index, 0, reorderedItem);
    this.setState({ gridColumns: items });
  };

  setFrmValues(type) {
    //console.log(this.state.gridColumns, "this.state.gridColumns");
    var finalColumnList = [];
    this.state.gridColumns.map(
      (item) => {
        if (item.visible) {
          finalColumnList.push(item);
        }
      });

    if (typeof type != "undefined") {
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/leads/save-report-columns`,
        data: {
          reportType: this.props.report,
          finalColumnList: finalColumnList,
        },
      }).then(function (response) {
        console.log(response.data, "response");
        // ths.setState({ gridColumns: response.data });
        // ths.props.setLoadedColumns(response.data);
      });
    }

    // console.log(finalColumnList,'final column list');
    this.props.setGridColumns(finalColumnList);
    this.props.handleMergeAction(finalColumnList);
    //this.props.setLoadedColumns(this.state.gridColumns);
    this.props.handleClose(false);
  }

  render() {
    return (
      <div
        className="parentContainer"
        style={{
          // float: "right",
          // width: "80%",
          display: "block",
          overflowY: "auto",
          overflowX: "hidden",
          height: "100%",
        }}
      >
        <div>
          {this.renderForm()}
        </div>
      </div>
    );
  }

  renderForm() {
    // NewData=[{grow: 1,id: 1,name: "Created at",selector: "created at",sortable: false,visible: true},{grow: 1,id: 2,name: "Approved date",selector: "Approved Date",sortable: false,visible: true}]
    return (

      <div>
        <Formik>
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,

            resetForm,
          }) => (
            <div className="">
              <Form autoComplete="off" >
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="text-center" style={{ fontSize: "16px" }}>
                        Select Columns
                      </h4>
                      <DragDropContext onDragEnd={this.handleOnDragEnd}>
                        <Droppable droppableId="filterColumnsList">
                          {(provided) => (
                            <ul
                              className="filterColumnsList"
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {this.state.gridColumns.map((item, index) => (
                                <Draggable
                                  key={item.id}
                                  draggableId={"" + item.id}
                                  index={index}
                                  type="TASK"
                                >
                                  {(provided) => (
                                    <li
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                    >
                                      <label>
                                        <input
                                          checked={item.visible}
                                          type="checkbox"
                                          value={item.name}
                                          index={index}
                                          onChange={this.handleChange}
                                        />{" "}
                                        {item.name}
                                      </label>
                                    </li>
                                  )}
                                </Draggable>
                              ))}



                            </ul>
                          )}
                        </Droppable>
                      </DragDropContext>
                      {/* <table
                        className="selectColumnsTable"
                        style={{ width: "100%", margin: "0" }}
                      >
                        {this.state.gridColumns.map((item, index) => (
                          <tr style={{ marginBottom: "5px" }}>
                            <td
                              style={{
                                padding: "10px",
                              }}
                            >
                              <label>
                                <input
                                  checked={item.visible}
                                  type="checkbox"
                                  value={item.name}
                                  index={index}
                                  onChange={this.handleChange}
                                />{" "}
                                {item.name}
                              </label>
                            </td>
                          </tr>
                        ))}
                      </table> */}
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-lg-12 p-0">
                      <div className="button_group d-flex align-items-center gap-3 justify-content-end">
                        <button
                          className="add_button"
                          type="reset"
                          onClick={(e) => {
                            this.setFrmValues();
                          }}
                        >
                          Filter
                        </button>
                        <button
                          className="update_button"
                          type="reset"
                          onClick={(e) => {
                            this.setFrmValues(1);
                          }}
                        >
                          Save & Filter
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    );
  }
}

export default withRouter(ReportsColumnSelectionView);
